module.exports = __webpack_public_path__ + "static/media/logo-punto-seguido.aaaeb2e1.svg";